import { render, staticRenderFns } from "./LegoViewTusTableros.vue?vue&type=template&id=d4a2f8ea&scoped=true"
import script from "./LegoViewTusTableros.vue?vue&type=script&lang=js"
export * from "./LegoViewTusTableros.vue?vue&type=script&lang=js"
import style0 from "./LegoViewTusTableros.vue?vue&type=style&index=0&id=d4a2f8ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4a2f8ea",
  null
  
)

export default component.exports